var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowRightBrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1875 9C3.1875 8.68934 3.43934 8.4375 3.75 8.4375H14.25C14.5607 8.4375 14.8125 8.68934 14.8125 9C14.8125 9.31066 14.5607 9.5625 14.25 9.5625H3.75C3.43934 9.5625 3.1875 9.31066 3.1875 9Z",
    fill: "#542F1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60225 3.35225C8.82192 3.13258 9.17808 3.13258 9.39775 3.35225L14.6477 8.60225C14.8674 8.82192 14.8674 9.17808 14.6477 9.39775L9.39775 14.6477C9.17808 14.8674 8.82192 14.8674 8.60225 14.6477C8.38258 14.4281 8.38258 14.0719 8.60225 13.8523L13.4545 9L8.60225 4.14775C8.38258 3.92808 8.38258 3.57192 8.60225 3.35225Z",
    fill: "#542F1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightBrown);
export default __webpack_public_path__ + "static/media/ic_arrow_right_brown.db1d678cfcd15806e03912ad170f5e34.svg";
export { ForwardRef as ReactComponent };